var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sitch-data-table-info mobile-only"},[_c('fa',{attrs:{"icon":['fal', 'hand-point-up']}}),_c('span',{directives:[{name:"t",rawName:"v-t",value:('scrollRightForActions'),expression:"'scrollRightForActions'"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }